import BigNumber from 'bignumber.js';
import { ETHER, HUMAN_DECIMALS, PRECISE_DECIMALS } from 'shared/lib/token/constants';
import { parseUnits } from 'viem';

// overloads
export function formatUnits(amount: string | BigNumber | number | bigint, decimals?: number): string;

export function formatUnits(
  amount: string | BigNumber | number | bigint,
  decimals: number | undefined,
  stringify: true,
): string;

export function formatUnits(
  amount: string | BigNumber | number | bigint,
  decimals: number | undefined,
  stringify: false,
): BigNumber;

// implementation
export function formatUnits(
  amount: string | BigNumber | number | bigint,
  decimals = 18,
  stringify = true,
): string | BigNumber {
  const value = new BigNumber(amount.toString()).dividedBy(new BigNumber(10).pow(decimals));

  if (stringify) return value.toFixed();

  return value;
}

export const parseAmountEther = (amount: string, decimals = 18) => {
  return new BigNumber(amount).multipliedBy(new BigNumber(10).pow(decimals));
};

export const parseValueSafe = (value: string, decimals = 18): BigNumber | null => {
  try {
    const [, fraction = '0'] = value.split('.');
    const trimmedFraction = fraction.replace(/(0+)$/, '');

    if (trimmedFraction.length > decimals) return null;

    return new BigNumber(parseUnits(value, decimals).toString());
  } catch {
    return null;
  }
};

export const weiToEther = (wei: BigNumber | string) => new BigNumber(wei).div(ETHER);

export const formatWEI = (input: BigNumber, manyDigits: boolean) => {
  const decimals = manyDigits ? PRECISE_DECIMALS : HUMAN_DECIMALS;
  const inWei = weiToEther(input).decimalPlaces(decimals);

  return inWei.toFormat();
};
